import { container, singleton } from "tsyringe";
import toValidationError from "utils/toValidationError";
import PosterApi from "api/clapaction/projects/[id]/PosterApi";

@singleton()
export default class PosterService {
	private api: PosterApi = container.resolve(PosterApi);

	public async getPosterImage(projectId: string): Promise<Blob | null> {
		return this.api.getPosterImage(projectId).catch(() => null);
	}

	public async changeGeneratedPosterImage(projectId: string) {
		return this.api.changeGeneratedPosterImage(projectId);
	}

	public async canDiscardGeneratedPosterImage(projectId: string) {
		return this.api.canDiscardGeneratedPosterImage(projectId);
	}

	public async updatePoster(projectId: string, file: File) {
		return this.api.updatePoster(projectId, file).catch(toValidationError);
	}
}
